(ns ncr.etc.parse-numbers
  (:require [clojure.string :as s])
  (:import [goog.i18n NumberFormat NumberFormatSymbols_de NumberFormatSymbols_en NumberFormatSymbolsType]))

(def regexp-special-chars "\\^$*+?.()|[]{}")

(defn re-quote-replacement
  "Replaces `s` with a string that can be used in a regular expression."
  [s]
  (->> s
    (map (fn [c] (str (when (some #{c} regexp-special-chars) "\\") c)))
    (apply str)))


(defn parse-closure-pattern
  "Accepts a Google Closure NumberFormat pattern and returns a vector with group size and decimal size.
  All Google Closure NumberFormat patterns are using `,` as group separator and `.` as decimal separator."
  [pattern]
  (map (comp count second #(re-find % pattern)) [#"(?:[^,]*,)([#\d]+)(?:\.)" #"\.([^.]*)$"]))

(defn sanitize-currency-pattern
  "Accepts a Google Closure NumberFormat CURRENCY_PATTERN and returns a sanitized version of it."
  [pattern]
  (s/replace pattern #"[ \u00A4\u00A0]" ""))

(defn trim-non-digits
  "Trims any non-digit characters from the beginning and end of a given string,
  preserving the content between the first and last digits."
  [s]
  (let [first-digit (re-find #"\d" s)
        last-digit (re-find #"\d" (s/reverse s))]
    (subs s (if first-digit (.indexOf s first-digit) 0)
      (if last-digit (- (count s) (.indexOf (s/reverse s) last-digit)) 1))))
(defn get-group
  "Returns group part of a formatted number `s` or empty string if no group part is present.
  Returns `nil`, if group part is present but invalid."
  [group-separator group-size decimal-separator s]
  (second
    (re-find
      (re-pattern
        (str "^(\\d{1," group-size "}(?:" (re-quote-replacement group-separator)
          "\\d{" group-size "})*|\\d+)(?=(?:" (re-quote-replacement decimal-separator) "\\d*)|$)")) s)))

(defn get-decimal
  "Returns decimal part of a formatted number `s` or empty string if no decimal part is present.
  Returns `nil` if decimal part is present but invalid."
  [decimal-separator decimal-size s]
  (if-let [d (some->> (s/index-of s decimal-separator) inc (subs s))]
    (when (re-matches (re-pattern (str "^\\d{" decimal-size "}$")) d)
      (str decimal-separator d))
    ""))

(defn validate
  "Parses number into group and decimal and returns them as a vector. Returns `nil`, if either is invalid."
  [group-separator group-size decimal-separator decimal-size s]
  (let [group (get-group group-separator group-size decimal-separator s)
        decimal (get-decimal decimal-separator decimal-size s)]
    (when (and group decimal)
      [group decimal])))

(defn get-sanitized-currency-pattern [^NumberFormatSymbolsType symbols]
  (sanitize-currency-pattern (.-CURRENCY_PATTERN symbols)))

(defn parse-with [s ^NumberFormatSymbolsType symbols & {:keys [group-separator decimal-separator]}]
  (let [pattern (get-sanitized-currency-pattern symbols)
        [group-size decimal-size] (parse-closure-pattern pattern)
        trimmed (trim-non-digits s)]
    (when (validate
            (or group-separator (.-GROUP_SEP symbols)) group-size
            (or decimal-separator (.-DECIMAL_SEP symbols)) decimal-size
            trimmed)
      (set! (.-NumberFormatSymbols goog.i18n) symbols)
      (.parse (NumberFormat. pattern) (s/replace trimmed #"\s" "")))))

(defn parse-all [s]
  (sequence
    (comp (map #(some->> % (apply parse-with s))) (filter identity) (dedupe))
    [[NumberFormatSymbols_de] [NumberFormatSymbols_de :group-separator " "]
     [NumberFormatSymbols_en] [NumberFormatSymbols_en :group-separator " "]]))
